/**
 * Created by zhaoy on 2020/07/11
 * Desc: 学生名单
 */

export default function RosterBean() {
    this.stuId = '' //学生id
    this.stuName = '' //学生姓名
    this.stuBindingState = '' //学生绑定状态
    this.parentsList = [] //家长信息
    this.changType = '' //卡状态
    this.stuTeacherCard = '' //在线挂失
}